import styled from 'styled-components';

export const LogTableWrapper = styled.div`
  font-size: 12px;

  .ant-table-thead th {
    vertical-align: top;
    background-color: #fff;
    white-space: nowrap;
    padding: 8px 4px 8px 4px;
  }
  .ant-table-tbody td {
    vertical-align: top;
    padding: 8px 4px 8px 4px;
    border: 1px solid #d0d7e3;
    background-color: #f7f7f8;
    font-size: 10px;
    color: #31394d;
    font-weight: 400;
  }
`;

export const RunInstanceIdTitle = styled.div`
  font-size: 14px;
  padding-bottom: 8px;
`;
export const CustomHeader = styled.div`
  font-size: 11px;
  color: #748aa1;
  font-weight: 400;
  line-height: 16px;
  align-items: center;
  background: #fff;
`;
export const ActivityLogHeader = styled.div`
  padding: 4px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const CompletedStatus = styled.div`
  line-height: 22px;
  padding: 0 8px;
  color: #ffffff;
  background-color: #71c969;
  border-radius: 4px;
  text-align: center;
`;

export const InProgressStatus = styled.div`
  line-height: 22px;
  padding: 0 8px;
  color: #ffffff;
  background: #3e7ad3;
  border-radius: 4px;
  text-align: center;
`;
export const FailedStatus = styled.div`
  line-height: 22px;
  padding: 0 8px;
  color: #ffffff;
  background: #df6057;
  border-radius: 4px;
  text-align: center;
  letter-spacing: 0.5px;
`;

export const InQueueStatus = styled.div`
  line-height: 22px;
  padding: 0 8px;
  color: #ffffff;
  background: #7e7e7e;
  border-radius: 4px;
  text-align: center;
  letter-spacing: 0.5px;
`;

export const GoodAlert = styled.div`
  color: #eb922a;
`;

export const HighAlert = styled.div`
  color: #e94e43;
`;

export const LowAlert = styled.div`
  color: #49c93d;
`;

export const CentralContainer = styled.div`
  display: grid;
  place-content: center;
`;
